import { Formik } from 'formik';
import { Link } from 'react-router-dom';

import AuthForm from './AuthForm';
import AuthInput from './AuthInput';
import AuthSub from './AuthSub';
import AuthSubmit from './AuthSubmit';
import { usernameOnlySchema } from './schemas/username-only.schema';

import { AuthRoutes } from '@/interfaces/auth/AuthRoutes.enum';

type PropTypes = {
	handleSubmit: (username: string) => Promise<void>;
	loading: boolean;
};
export default function ForgotPasswordForm({
	handleSubmit,
	loading,
}: PropTypes) {
	const initialValues = {
		username: '',
	};
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={usernameOnlySchema}
			onSubmit={({ username }) => handleSubmit(username)}
		>
			{({ errors, touched }) => (
				<AuthForm>
					<AuthInput
						name="username"
						label="Username"
						type="email"
						placeholder="Email"
						error={!!errors.username}
						touched={touched.username}
						data-test="forgot-password-username"
					/>
					<AuthSubmit
						label="Send Code"
						isLoading={loading}
						data-test="forgot-password-submit"
						className="bg-purpleBrand-500 hover:bg-purpleBrand-600 active:bg-purpleBrand-900"
					/>
					<AuthSub>
						<p>
							Already have an account?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.SignIn}
								data-test="link-sign-in"
							>
								Sign in
							</Link>
						</p>
						<p>
							Don't have an account?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.SignUp}
								data-test="link-sign-up"
							>
								Sign up
							</Link>
						</p>
						<p>
							Already have your code?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.ConfirmPassword}
								data-test="link-confirm-password"
							>
								Click here
							</Link>
						</p>
					</AuthSub>
				</AuthForm>
			)}
		</Formik>
	);
}
